<template>
    <div>
        <div class="row">
            <div class="col-lg-4 col-md-4 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">دسته بندی :</span>
                    </div>
                    <vs-select :data="categories" :mode="'create'"
                               :header="{multiple: false, label: 'name'}"
                               @onChange="onSelectCategory"></vs-select>
                </div>
            </div>
            <div class="col-12 col-md-4 col-lg-4 mt-2">
                <div class="input-group">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                    </div>
                    <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                           v-model="searchString">
                    <button type="button" class="d-inline-block btn btn-info mx-2 barcode"
                            @click="openBarcode"><i
                            class="fa fa-camera"></i></button>
                </div>
            </div>
        </div>
        <hr/>
        <div class="row" v-if="listView">
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-3">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-3">
                            <strong>موجودی: </strong>
                            <span>{{item.stock < 0 ? '(' + (item.stock * -1).toLocaleString()+"-)": item.stock.toLocaleString()}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>بارکد: </strong>
                            <span>{{item.barcode}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>شناسه: </strong>
                            <span>{{item.technicalCode}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div class="card product mt-2 mb-2" @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>
                            <span>موجودی انبار: </span>
                            <span>{{item.stock < 0 ? '(' + (item.stock * -1).toLocaleString()+"-)": item.stock.toLocaleString()}}</span>
                            <br>
                            <span>بارکد: </span>
                            <span>{{item.barcode}}</span>
                            <br>
                            <span>شناسه: </span>
                            <span>{{item.technicalCode}}</span>
                        </div>
                        <div class="col-4">
                            <img src="../../assets/img/placeholder.png" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div v-if="products !== undefined && products.length < 1" class="col-lg-12 text-center mt-5 mb-3">
                <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
            </div>
            <div v-if="products.length < dataCount" class="col-lg-12 text-center mb-3" @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle1">محصولات فاکتور</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th class=" text-nowrap">نام محصول</th>
                                        <th class="text-center text-nowrap">تعداد</th>
                                        <th class="text-center  text-nowrap"
                                            v-if="voucher.voucher !== undefined && (voucher.voucher.voucherType === 2 || voucher.voucher.voucherType !== 1)">فی خرید
                                        </th>
                                        <th class="text-center text-nowrap" v-if="voucher.voucher !== undefined && voucher.voucher.voucherType === 1">قیمت فروش</th>
                                        <th class="text-center  text-nowrap">تخفیف</th>
                                        <th class="text-center  text-nowrap">جمع</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="voucher !== undefined">
                                    <tr v-for="(item,index) in voucher.products">
                                        <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                        <td>{{item.productName}}</td>
                                        <td class="text-center">
                                            {{item.unitVal}}
                                        </td>
                                        <td class="text-center" v-if="voucher.voucher !== undefined && (voucher.voucher.voucherType === 2 || voucher.voucher.voucherType !== 1)">
                                            {{item.price.toLocaleString()}}
                                        </td>
                                        <td class="text-center" v-if="voucher.voucher !== undefined && voucher.voucher.voucherType === 1">
                                            {{item.salesPrice.toLocaleString()}}
                                        </td>
                                        <td class="text-center">
                                            {{item.discount.toLocaleString()}}
                                        </td>
                                        <td class="text-center">
                                            {{(item.unitVal * (item.price- item.discount)).toLocaleString()}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left"><b>جمع</b></td>
                                        <td class="text-center"><b>{{overallAmount.toLocaleString()}}</b></td>
                                        <td class="text-center" v-if="voucher.voucher !== undefined">
                                            <b>{{voucher.voucher.price.toLocaleString()}}</b>
                                        </td>
                                        <td class="text-center" v-if="voucher.voucher !== undefined">
                                            <b>{{(voucher.voucher.totalDiscount).toLocaleString()}}</b>
                                        </td>
                                        <td class="text-center" v-if="voucher.voucher !== undefined">
                                            <b>{{(voucher.voucher.price - voucher.voucher.totalDiscount).toLocaleString()}}</b>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center mt-5"
                                    v-if=" voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت
                                    نشده است!</h4>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تخفیف فاکتور</span>
                                </div>
                                <span v-if="voucher.voucher !== undefined" class="form-control text-right">{{voucher.voucher.discount.toLocaleString()}}</span>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input v-if="voucher.voucher !== undefined" class="form-control" type="text"
                                       v-model="voucher.voucher.description" placeholder="توضیحات" disabled>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <div class="text-right w-100">
                                <span>سند </span>
                                <span v-if="voucher.voucher !== undefined && voucher.voucher.voucherType === 1">فروش - مشتری
                                {{voucher.voucher !== undefined ? voucher.voucher.receiveOutSourceName:''}}</span>
                                <span v-else>خرید-فروشنده
                                {{voucher.voucher !== undefined ? voucher.voucher.serveOutsourceName:''}}</span>
                                <span>شماره :</span>
                                <span v-if="voucher.voucher !== undefined">{{voucher.voucher.voucherNumber}}</span>
                            </div>
                            <div class="text-right w-100">
                                <span>تاریخ سند: </span>
                                <span v-if="voucher.voucher !== undefined">{{voucher.voucher.persianDate}}</span>
                            </div>

                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="kardexModal" tabindex="-1" role="dialog" aria-labelledby="kardexTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-danger-grad glow-danger">
                            <h5 class="modal-title text-white" id="kardexTitle">
                                گزارش کاردکس
                                {{prodName}}
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" id="printMe">
                            <div class="row">
                                <div v-if="!listView" class="row mx-2">
                                    <div class="col-lg-6 col-md-6 col-12 mb-3" v-for="(item, index) in kardex"
                                         @click="onKardexItemClicked(index)">
                                        <div class="card kardex p-2">
                                            <div class="row">
                                                <!--<div class="col-9">-->
                                                    <!--<h4>{{item.productName}}</h4>-->
                                                <!--</div>-->
                                                <div class="col-5">
                                                    <strong v-if="item.voucher.voucherType === 2">خرید</strong>
                                                    <strong v-if="item.voucher.voucherType === 1">فروش</strong>
                                                    <strong v-if="item.voucher.voucherType === 5">موجودی</strong>
                                                    <!--<strong v-if="item.voucher.voucherType === 6">تولید شده</strong>-->
                                                    <!--<strong v-if="item.voucher.voucherType === 7">مصرف برای تولید</strong>-->
                                                </div>
                                                <div class="col-7">
                                                    <strong>مبلغ سند: </strong>
                                                    <span>{{item.voucher.price.toLocaleString()}}</span>
                                                </div>
                                                <div class="col-5">
                                                    <strong>تعداد: </strong>
                                                    <span>{{item.unitVal}}</span>
                                                </div>
                                                <div class="col-7">
                                                    <strong>تاریخ سند: </strong>
                                                    <span>{{item.voucher.fvoucherDate}}</span>
                                                </div>
                                                <div class="col-12">
                                                    <strong>توضیحات سند: </strong>
                                                    <span>{{item.voucher.description}}</span>
                                                </div>
                                            </div>

                                        </div>
                                        <div v-if=" kardex.length
                                < 1" class="col-lg-12 mt-3">
                                            <h4 class="no-item-alert text-center">محصول در هیچ سندی ثبت نشده
                                                است!</h4>
                                        </div>
                                        <!--<div v-if="kardex.length < kardexCount" class="col-lg-12 text-center"-->
                                        <!--@click="getKardex">-->
                                        <!--<button class="btn btn-success">نمایش فاکتور</button>-->
                                        <!--</div>-->
                                    </div>
                                </div>
                                <div v-else class="col-12">
                                    <div class="table-responsive">
                                        <h6 class="text-center">گزارش موجودی
                                            {{prodName}}
                                        </h6>
                                        <table class="table table-hover table-striped text-center">
                                            <thead>
                                            <tr>
                                                <th class="text-center text-nowrap border-right" style="vertical-align: inherit !important;" rowspan="2">تاریخ (مشاهده فاکتور)</th>
                                                <th class="text-center text-nowrap border-right" colspan="3">خرید/موجودی(+)</th>
                                                <th class="text-center text-nowrap border-right" colspan="3">فروش</th>
                                                <th class="text-center text-nowrap border-right border-left" style="vertical-align: inherit !important;" rowspan="2">مانده</th>
                                            </tr>
                                            <tr>
                                                <!--<th class="text-center text-nowrap"></th>-->
                                                <th class="text-center text-nowrap border-right">تعداد</th>
                                                <th class="text-center text-nowrap">فی</th>
                                                <th class="text-center text-nowrap">مبلغ</th>

                                                <th class="text-center text-nowrap border-right">تعداد</th>
                                                <th class="text-center text-nowrap">فی</th>
                                                <th class="text-center text-nowrap border-left">مبلغ</th>
                                                <!--<th class="text-center text-nowrap"></th>-->
                                            </tr>

                                            </thead>
                                            <tbody>
                                            <tr v-for="(item,index) in voucherProds">
                                                <td class="text-center  text-nowrap clickable border-right" @click="onProductItemClicked(index)">
                                                    {{voucherProds[index].voucher.persianDate}}
                                                </td>
                                                <td class="text-center text-nowrap border-right">
                                                    {{voucherProds[index].voucher.voucherType === 2 || voucherProds[index].voucher.voucherType === 5 ||
                                                    voucherProds[index].voucher.voucherType === 6
                                                    ?
                                                    voucherProds[index].products[0].unitVal : "---"}}
                                                    {{voucherProds[index].voucher.voucherType === 6 ? "*":""}}
                                                    {{voucherProds[index].voucher.voucherType === 5 ? "+":""}}
                                                </td>
                                                <td class="text-center text-nowrap">
                                                    {{voucherProds[index].voucher.voucherType === 2 || voucherProds[index].voucher.voucherType === 5 ||
                                                    voucherProds[index].voucher.voucherType === 6
                                                    ?
                                                    voucherProds[index].products[0].price.toLocaleString() : "---"}}
                                                </td>
                                                <td class="text-center text-nowrap">
                                                    {{voucherProds[index].voucher.voucherType === 2 || voucherProds[index].voucher.voucherType === 5 ||
                                                    voucherProds[index].voucher.voucherType === 6
                                                    ?
                                                    (voucherProds[index].products[0].unitVal *
                                                    voucherProds[index].products[0].price).toLocaleString() : "---"}}
                                                </td>
                                                <td class="text-center text-nowrap border-right">
                                                    {{voucherProds[index].voucher.voucherType === 1 || voucherProds[index].voucher.voucherType === 7
                                                    ?
                                                    voucherProds[index].products[0].unitVal : "---"}}
                                                    {{voucherProds[index].voucher.voucherType === 7 ? "#":""}}
                                                </td>
                                                <td class="text-center text-nowrap">
                                                    {{voucherProds[index].voucher.voucherType === 1 || voucherProds[index].voucher.voucherType === 7
                                                    ?
                                                    voucherProds[index].products[0].salesPrice.toLocaleString() : "---"}}
                                                </td>
                                                <td class="text-center text-nowrap border-left">
                                                    {{voucherProds[index].voucher.voucherType === 1 || voucherProds[index].voucher.voucherType === 7
                                                    ?
                                                    (voucherProds[index].products[0].unitVal *
                                                    voucherProds[index].products[0].salesPrice).toLocaleString() : "---"}}
                                                </td>
                                                <!--<td class="text-center text-nowrap">-->
                                                <!--{{voucherProds[index].voucher.voucherType === 1-->
                                                <!--?-->
                                                <!--voucherProds[index].products[0].unitVal : "-&#45;&#45;"}}-->
                                                <!--</td>-->
                                                <td class="text-center text-nowrap border-left">
                                                    {{voucherProds[index].products[0].rem}}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                    class="fa fa-print"></i></button>
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="modal fade" id="barcodeModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"-->
            <!--aria-hidden="true">-->
            <!--<div class="modal-dialog modal-lg modal-dialog-centered" role="document">-->
            <!--<div class="modal-content">-->
            <!--<div class="modal-header bg-warning-grad glow-warning">-->
            <!--<h5 class="modal-title text-white" id="voucherTitle">خواندن بارکد-->
            <!--محصول</h5>-->

            <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
            <!--<span aria-hidden="true">&times;</span>-->
            <!--</button>-->
            <!--</div>-->
            <!--<div class="modal-body mt-3">-->
            <!--<div class="row">-->
            <!--<div class="col-12">-->

            <!--<StreamBarcodeReader-->
            <!--@decode="(a, b, c) => onDecode(a, b, c)"-->
            <!--@loaded="() => onLoaded()"-->
            <!--&gt;</StreamBarcodeReader>-->
            <!--<h5 class="col-12 text-center m-3">{{ barcode || "هیچ بارکدی قرائت نشده، لطفا دوربین را روی بارکد بگیرید" }}</h5>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="modal-footer mt-3">-->
            <!--<button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>-->
            <!--&lt;!&ndash;<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>&ndash;&gt;-->
            <!--&lt;!&ndash;<button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>&ndash;&gt;-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->


        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import VsSelect from '../../_framework/VsSelect.vue';
    import VueHtmlToPaper from 'vue-html-to-paper';
    import {StreamBarcodeReader} from "vue-barcode-reader";


    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'inventoryLessProduct',
        components: {
            VsSelect,
            StreamBarcodeReader
        },
        data() {
            return {
                products: [],
                categories: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                },

                kardex: [],
                voucherProds: [],
                voucher: {},
                overallAmount: 0,
                dataCount: 0,
                kardexCount: 0,

                listView: false,
                searchString: "",
                prodName: "",
                barcode: "",
            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            new BaseService('product', '/getmylessproducts').getList(this.queryParams).then(response => {
                this.products = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
            }).catch(error => {
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            new BaseService('categories').getAll().then(response => {
                this.categories = response.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });


        },
        methods: {
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            getProducts() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('product', '/getmylessproducts').getList(this.queryParams).then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSelectCategory(val) {
                this.queryParams.categoryId = val.id;
                this.queryParams.pageIndex = 0;
                $("#loading").hide();
                new BaseService('product', '/get').getList(this.queryParams).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products = response.data.data;
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },
            onCardClicked(e, index) {
                this.prodName = this.products[index].productName;
                if (this.listView) {
                    // this.queryParams.productId = this.products[index].id;
                    new BaseService('voucher', '/getProductAllVouchers/' + this.products[index].id).getList(this.queryParams).then(response => {
                        this.voucherProds = response.data;
                        let rem = 0;
                        for (let pro of this.voucherProds) {
                            if (pro.voucher.voucherType === 2 || pro.voucher.voucherType === 5 || pro.voucher.voucherType === 6) {
                                rem += pro.products[0].unitVal;
                                pro.products[0].rem = rem.toFixed(3);
                            }

                            if (pro.voucher.voucherType === 1 || pro.voucher.voucherType === 7) {
                                rem -= pro.products[0].unitVal;
                                pro.products[0].rem = rem.toFixed(3);
                            }
                            pro.voucher.fvoucherDate = Moment(pro.voucher.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                        // this.kardexCount = response.data.count;
                        $("#kardexModal").modal('show');
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                } else {
                    this.queryParams.productId = this.products[index].id;
                    new BaseService('reports', '/getkardexrreport').getList(this.queryParams).then(response => {
                        this.kardex = response.data.data;
                        this.kardexCount = response.data.count;
                        for (let pro of this.kardex) {
                            pro.voucher.fvoucherDate = Moment(pro.voucher.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                        // console.log(this.kardex)
                        $("#kardexModal").modal('show');
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                    /*this.overallAmount = 0;
                    let id = this.vouchers[index].id;
                    new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                        this.voucher = response.data;
                        for (let item of this.voucher.products) {
                            this.overallAmount += item.unitVal;
                        }
                        $("#voucherData").modal("show");
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    })*/
                }
            },
            onKardexItemClicked(index) {
                this.overallAmount = 0;
                let id = this.kardex[index].voucher.id;
                console.log(index)
                console.log(id)
                $("#kardexModal").modal('hide');
                $("#voucherData").modal('show');
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onProductItemClicked(index) {
                this.overallAmount = 0;
                let id = this.voucherProds[index].voucher.id;
                console.log(index)
                console.log(id)
                $("#kardexModal").modal('hide');
                $("#voucherData").modal('show');
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getKardex() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('reports', '/getkardexrreport').getList(this.queryParams).then(response => {
                    this.kardex.push.apply(this.kardex, response.data.data);
                    $("#kardexModal").modal('show');
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                let queryParams2 = {
                    name: this.searchString,
                    showAll: false,
                    pageSize: 18,
                    pageIndex: 0,
                };
                $("#loading").hide();
                new BaseService('product', '/getmylessproducts').getList(this.queryParams).then(response => {
                    this.products = response.data.data;
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onDecode(a, b, c) {
                console.log(a, b, c);
                this.barcode = a;
                this.searchString = a;
                this.onSearchInput();
                $("#barcodeModal").modal("hide");
                // if (this.id) clearTimeout(this.id);
                // this.id = setTimeout(() => {
                //     if (this.text === a) {
                //         this.text = "";
                //     }
                // }, 5000);
            },
            onLoaded() {
                console.log("load");
            },
            openBarcode() {
                this.barcode = "";
                $("#barcodeModal").modal("show");
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                if ($("#kardexModal").hasClass("show")) {
                    $("#kardexModal").modal("hide");
                    next(false);
                } else {
                    next();
                }
            }


        },
    }
</script>

<style lang="scss" scoped>
    .card.kardex {
        border: 1px dotted grey;
        box-shadow: 0 7px 25px -5px rgba(0, 0, 0, 0.5);
        transition: all 0.3s;
    }

    .card.kardex:hover {
        cursor: pointer;
        transform: translateY(-5px);
    }

    @media (max-width: 991px) {
        .barcode {
            display: block !important;
        }
    }

    @media (min-width: 990px) {
        .barcode {
            display: none !important;
        }
    }

</style>